export default __webpack_public_path__ + "static/media/session_link.8090a910.svg";